module.exports = __webpack_public_path__ + "media/components/assets/img/icons/ios/add-homescreen-5874d58491eaee7092db2fb3cd516539.svg";